import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ViewCategoryDetails } from '../../../../components/admin-dashboard-component/categories/view-category-details/view-category-details';

@Component({
  selector: 'app-view-category',
  imports: [ViewCategoryDetails],
  templateUrl: './view-category.html',
  styleUrl: './view-category.scss',
})
export class ViewCategory implements OnInit {
  categoryId: number | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    const id = this.route.snapshot.params['id'];
    this.categoryId = id ? +id : null;
  }
}
